import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api';
import { useAuth } from '../contexts/AuthContext';

const inputClass =
  'w-full rounded-lg border border-leather bg-leather/30 px-3 py-2 text-white placeholder-station-muted focus:ring-2 focus:ring-gold focus:border-gold';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login: setAuth } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!email.trim() || !password) return;
    setLoading(true);
    try {
      const res = await login(email.trim(), password);
      if (res.role === 'owner') {
        setAuth({ role: 'owner' });
        navigate(res.redirect || '/dashboard', { replace: true });
      } else if (res.role === 'partner') {
        setAuth(res.partnerId != null ? { role: 'partner', partnerId: res.partnerId } : { role: 'partner' });
        if (res.partnerId != null) navigate(res.redirect || `/portal/${res.partnerId}`, { replace: true });
        else { setError('You do not have access to the dashboard.'); setLoading(false); }
      } else {
        setError('Invalid response from server');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-charcoal p-4">
      <div className="w-full max-w-sm rounded-xl border border-leather bg-leather/40 p-6">
        <h1 className="text-xl font-semibold text-gold mb-2">The Station</h1>
        <p className="text-station-muted text-sm mb-4">Sign in to the Performance Portal</p>
        {error && (
          <div className="mb-4 p-3 rounded-lg bg-red-500/20 border border-red-400/50 text-red-300 text-sm">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className={inputClass}
            required
            autoComplete="email"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className={inputClass}
            required
            autoComplete="current-password"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-gold text-charcoal font-medium py-2.5 hover:bg-gold/90 transition-colors disabled:opacity-50"
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <p className="mt-4 text-center text-station-muted text-xs">
          Admins go to the dashboard. Partners go to their portal.
        </p>
      </div>
    </div>
  );
}
